module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "adminActivities"
  }, [_c('Navigation', {
    attrs: {
      "showPromoterNav": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row m-t-6"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nameFilter),
      expression: "nameFilter"
    }],
    attrs: {
      "type": "text",
      "placeholder": "nome"
    },
    domProps: {
      "value": (_vm.nameFilter)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.nameFilter = $event.target.value
      }, function($event) {
        _vm.setNameFilter()
      }]
    }
  })]), _vm._v(" "), _c('th', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.promoterFilter),
      expression: "promoterFilter"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Promotor"
    },
    domProps: {
      "value": (_vm.promoterFilter)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.promoterFilter = $event.target.value
      }, function($event) {
        _vm.setPromoterFilter()
      }]
    }
  })]), _vm._v(" "), _c('th', [_vm._v("email")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.activities), function(activity) {
    return _c('tr', [_c('td', [(activity.translations[_vm.language]) ? _c('span', [_vm._v("\n                  " + _vm._s(activity.translations[_vm.language].name) + "\n                  "), _c('a', {
      attrs: {
        "href": '/' + _vm.language + '/activity/' + activity.slug,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-external-link",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e(), _vm._v(" "), (!activity.translations[_vm.language]) ? _c('span', [_vm._v("\n                  Tradução indisponivel\n                ")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(activity.promoter.data.company_name))]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(activity.promoter.data.user.data.email) + "\n              ")]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn",
      class: {
        'btn-primary': activity.is_highlight
      },
      on: {
        "click": function($event) {
          _vm.setHighlight(({
            is_highlight: !activity.is_highlight,
            id: activity.id
          }))
        }
      }
    }, [_vm._v("Destaque")]), _vm._v(" "), (activity.approved) ? _c('span', [_c('i', {
      staticClass: "fa fa-circle text-success",
      attrs: {
        "aria-hidden": "true"
      }
    }), _c('button', {
      staticClass: "btn btn-danger btn-sm",
      attrs: {
        "i": ""
      },
      on: {
        "click": function($event) {
          _vm.setApproved({
            approved: false,
            id: activity.id
          })
        }
      }
    }, [_vm._v("desaprovar")])]) : _vm._e(), _vm._v(" "), (!activity.approved) ? _c('span', [_c('i', {
      staticClass: "fa fa-circle text-danger",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default btn-sm",
      on: {
        "click": function($event) {
          _vm.setApproved(({
            approved: true,
            id: activity.id
          }))
        }
      }
    }, [_vm._v("aprovar")])]) : _vm._e()])])
  }))])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 m-t-2"
  }, [_c('h2', [_vm._v("Actividades")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6f34d462", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f34d462"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/AdminActivities.vue
// module id = 788
// module chunks = 3